import React, { useState } from "react";
import { Plus } from "lucide-react";
import TodoHeader from "./TodoHeader";
import TodoFilters from "./TodoFilters";
import TodoList from "./TodoList";
import AddTaskModal from "./AddTaskModal";

 export const SimpleTodoList = ({
  todos,
  setTodos,
  newTodoText,
  setNewTodoText,
  todoFilter,
  setTodoFilter,
  todoCategory,
  setTodoCategory,
  theme,
  language,
  t,
  styles,
  screenSize,
  addTodo,
  deleteTodo,
  toggleTodo,
}) => {
  const [showAddModal, setShowAddModal] = useState(false);

  const addLocalTodo = async (e) => {
    e.preventDefault();
    if (!newTodoText || !newTodoText.trim()) return;
    if (typeof addTodo === "function") {
      await addTodo(e);
      return;
    }
    const nt = {
      id: Date.now(),
      text: newTodoText.trim(),
      completed: false,
      category: todoCategory || "personal",
      createdAt: new Date().toISOString(),
    };
    setTodos([nt, ...todos]);
    setNewTodoText("");
  };

  const toggleLocal = async (id) => {
    if (typeof toggleTodo === "function") {
      await toggleTodo(id);
      return;
    }
    setTodos(todos.map((t) => (t.id === id ? { ...t, completed: !t.completed } : t)));
  };

  const deleteLocal = async (id) => {
    if (typeof deleteTodo === "function") {
      await deleteTodo(id);
      return;
    }
    setTodos(todos.filter((t) => t.id !== id));
  };

  const filtered =
    todoFilter === "active"
      ? todos.filter((t) => !t.completed)
      : todoFilter === "completed"
      ? todos.filter((t) => t.completed)
      : todos;

  const stats = {
    total: todos.length,
    completed: todos.filter((t) => t.completed).length,
    progress: todos.length
      ? Math.round(
          (todos.filter((t) => t.completed).length / todos.length) * 100
        )
      : 0,
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: screenSize.isMobile ? 16 : 20,
      }}
    >
      <TodoHeader
        todoStats={stats}
        t={t}
        theme={theme}
        screenSize={screenSize}
      />

      {/* Add Task Button */}
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowAddModal(true);
        }}
        style={{
          width: "100%",
          height: "56px",
          fontSize: "15px",
          fontWeight: "700",
          color: "#fff",
          background: "linear-gradient(135deg, #2e7cba 0%, #2e7cba 100%)",
          border: "none",
          borderRadius: "16px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow:
            "0 8px 24px rgba(16, 185, 129, 0.25), inset 0 -2px 8px rgba(0,0,0,0.1)",
          position: "relative",
          overflow: "hidden",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-3px) scale(1.01)";
          e.currentTarget.style.boxShadow =
            "0 12px 32px rgba(16, 185, 129, 0.35), inset 0 -2px 8px rgba(0,0,0,0.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0) scale(1)";
          e.currentTarget.style.boxShadow =
            "0 8px 24px rgba(16, 185, 129, 0.25), inset 0 -2px 8px rgba(0,0,0,0.1)";
        }}
      >
        <div
          style={{
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            background: "rgba(255,255,255,0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Plus size={20} strokeWidth={3} />
        </div>
        <span>{t.addTask}</span>
      </button>

      <TodoFilters
        todoFilter={todoFilter}
        setTodoFilter={setTodoFilter}
        todoStats={stats}
        t={t}
        theme={theme}
        screenSize={screenSize}
      />

      {/* Tasks List */}
      <div
        style={{
          maxHeight: screenSize.isMobile ? 300 : 360,
          overflowY: "auto",
          paddingRight: "4px",
        }}
      >
        <TodoList
          filteredTodos={filtered}
          theme={theme}
          screenSize={screenSize}
          t={t}
          onToggle={toggleLocal}
          onDelete={deleteLocal}
        />
      </div>

      <AddTaskModal
        show={showAddModal}
        newTodoText={newTodoText}
        setNewTodoText={setNewTodoText}
        todoCategory={todoCategory}
        setTodoCategory={setTodoCategory}
        onSubmit={addLocalTodo}
        onClose={() => setShowAddModal(false)}
        t={t}
        theme={theme}
        language={language}
      />

      <style>{`
        @keyframes slideIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default SimpleTodoList;
